import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OverlayModule } from '../overlay/overlay.module';
import { ContentTemplate, TooltipComponent } from './tooltip.component';

@NgModule({
  imports: [CommonModule, OverlayModule],
  declarations: [TooltipComponent, ContentTemplate],
  exports: [TooltipComponent, ContentTemplate],
})
export class TooltipModule {}
